import React from 'react';
import 'common/font/iconfont.css';

export default (props) => {
    const obj = Object.assign({}, props || {}, {
        'className': `icon iconfont icon-${props.type} ${props.className || ''}`
    });
    return <span {...obj}></span>;
}
